<template lang="pug">
v-container(fluid pa-0 ma-0 mb-2)
  template(v-if="item")
    v-card(outlined :ripple="false" :to="{ name: 'opportunity-item', params: { id: item.id } }" class="tw-cursor-pointer")
      v-row(dense justify-space-between align="center" class="tw-h-20 mr-2 ")
        v-col(cols="3" class="tw-h-full")
          div(class="tw-h-full tw-align-middle tw-bg-gr tw-overflow-hidden")
            div(
              :class="this.$formatters.oppStageColor(item.stage)"
              class="py-3 tw-w-full tw-text-center tw-h-full k-listing-opportunity-value tw-px-2"
            )
              span(class="tw-text-sm tw-font-bold tw-text-white") {{ this.$formatters.formatValue(item.amount) }}
              div(class="mt-1")
                v-chip(outlined color="white")
                  span(class="tw-font-bold tw-text-white") {{ $t(`Contacts.Common.${item.pivot.type}`) }}
        v-col(cols="")
          v-row(no-gutters)
            v-col
              router-link(class="tw-font-medium text-link" :to="{ name: 'opportunityDetail', params: { id: item.id } }") {{ item.name }}
          v-row(no-gutters justify="space-between" align="center")
            v-col(cols="stretch" class="pr-2")
              v-progress-linear(
                rounded
                height="6"
                :color="progress.color"
                background-color="blue-grey lighten-5"
                :value="progress.value"
              )
            v-col(cols="auto" class=" tw-text-right  ")
              span(class=" tw-text-sm tw-font-semibold tw-text-blueGray-lighten-1") {{ item.tasks_completed }} / {{ item.tasks_total }}
        v-col(cols="auto")
          v-row(no-gutters justify="end")
            v-col(class="tw-text-right ")
              div(
                class=" tw-w-24 tw-py-2 tw-px-1 tw-rounded tw-font-bold tw-text-sm tw-text-center tw-bg-opacity-50 tw-bg-blueGray-lighten-5 tw-text-blueGray-lighten-2"
              )
                span(class="tw-text-sm tw-font-light") {{ this.$moment(item.expected_close_date).format('MMM Do') }}
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
      required: true,
    },
  },
  computed: {
    progress() {
      let value = (this.item.tasks_completed / this.item.tasks_total) * 100;
      let progress = {};
      progress.value = value;
      switch (true) {
        case value <= 25:
          progress.color = '#FF808B';
          break;

        case value <= 50:
          progress.color = '#F4BE5E';
          break;

        case value <= 75:
          progress.color = '#5E81F4';
          break;

        case value <= 100:
          progress.color = '#7CE7AC';
          break;

        default:
          break;
      }
      return progress;
    },
  },
};
</script>
<style lang="scss" scoped>
.k-listing-opportunity-value {
  border-radius: 12px 0 0 12px;
}
</style>
